import { useProjectStore } from '../store/project-store';
export function useProject(projectId) {
    const projects = useProjectStore((s) => s.projects);
    const currentProjectId = useProjectStore((s) => s.currentProjectId);
    const setCurrentProject = useProjectStore((s) => s.setCurrentProject);
    const addProject = useProjectStore((s) => s.addProject);
    const updateProject = useProjectStore((s) => s.updateProject);
    const deleteProject = useProjectStore((s) => s.deleteProject);
    const activeId = projectId || currentProjectId;
    const currentProject = projects.find((p) => p.project_id === activeId) || null;
    return {
        projects,
        currentProject,
        setCurrentProject,
        addProject,
        updateProject,
        deleteProject,
    };
}
export function useTasks(projectId) {
    const allTasks = useProjectStore((s) => s.tasks);
    const addTask = useProjectStore((s) => s.addTask);
    const updateTask = useProjectStore((s) => s.updateTask);
    const deleteTask = useProjectStore((s) => s.deleteTask);
    const tasks = projectId
        ? allTasks.filter((t) => t.projectId === projectId)
        : allTasks;
    return { tasks, addTask, updateTask, deleteTask };
}
export function useSprints(projectId) {
    const allSprints = useProjectStore((s) => s.sprints);
    const addSprint = useProjectStore((s) => s.addSprint);
    const updateSprint = useProjectStore((s) => s.updateSprint);
    const deleteSprint = useProjectStore((s) => s.deleteSprint);
    const sprints = projectId
        ? allSprints.filter((s) => s.projectId === projectId)
        : allSprints;
    return { sprints, addSprint, updateSprint, deleteSprint };
}
export function useEpics(projectId) {
    const allEpics = useProjectStore((s) => s.epics);
    const addEpic = useProjectStore((s) => s.addEpic);
    const updateEpic = useProjectStore((s) => s.updateEpic);
    const deleteEpic = useProjectStore((s) => s.deleteEpic);
    const epics = projectId
        ? allEpics.filter((e) => e.projectId === projectId)
        : allEpics;
    return { epics, addEpic, updateEpic, deleteEpic };
}
//# sourceMappingURL=useProject.js.map